module.exports = __webpack_public_path__ + "img/edit-icon.1cdb2562.svg";